import { render, staticRenderFns } from "./DiskOfferingSelection.vue?vue&type=template&id=116f7a35&scoped=true&"
import script from "./DiskOfferingSelection.vue?vue&type=script&lang=js&"
export * from "./DiskOfferingSelection.vue?vue&type=script&lang=js&"
import style0 from "./DiskOfferingSelection.vue?vue&type=style&index=0&id=116f7a35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f7a35",
  null
  
)

export default component.exports